import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllAccessories = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/accessories',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveaccessory = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/accessories',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateaccessory = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/accessories/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteaccessory = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/accessories/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllAccessories,
  saveaccessory,
  deleteaccessory,
  updateaccessory,
}
